
import { Component, Injector, Input, ViewEncapsulation } from '@angular/core';
import { AbstractComponent } from '../../abstract.component';
import { MediaPictureService } from "../../../services/media-picture.service";

declare var window: any;

@Component({
  selector: 'user-recent-activity-card-v2',
  template: `
    <div class="eva-3-card user-recent-activity-item -eva-3-shadow-line">
      <div class="top-content" (click)="clickHandler(rowPosition, 'SEARCH_BUTTON', searchLink)" [ngClass]="{'-without-picture': !picture || !getPicture(picture)}">
      <div *ngIf="picture && getPicture(picture) as picture" class="image-container">
          <i class="product-icon -eva-3-mr-sm -eva-3-icon-lg eva-3-icon-{{iconName}}"></i>
          <div class="image-overlay"></div>
          <div class="content-image" style="background-image: url('{{picture}}')"></div>
        </div>
        
        <div class="content-container -eva-3-pr-md">
          <div class="product-title">
            <h3 class="user-recent-activity-title -eva-3-ellipsis" [ngClass]="isMobile ? 'eva-3-h6' : 'eva-3-h5'">{{title}}</h3>
          </div>

          <div *ngIf="drivers" class="user-recent-activity-details">
            <ng-container *ngFor="let driverText of drivers.level2">
              <span class="user-recent-activity-detail-2" [ngClass]="isMobile ? 'eva-3-caption' : 'eva-3-body-2'">{{driverText}}</span>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./user-recent-activity-card-v2.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserRecentActivityCardV2Component extends AbstractComponent {

  private static MODULE_ID = 'UserRecentActivityModule';
  private PICTURE_SIZE = "100x100";

  @Input() uniqueId: string;
  @Input() upaData: any;

  @Input() rowPosition: number;
  @Input() iconName: string;
  @Input() picture: string;
  @Input() productName: string;
  @Input() drivers: {
    level1?: string[];
    level2?: string[];
  };
  @Input() searchLink: string;
  @Input() searchLinkText: string;
  @Input() title: string;
  @Input() destinationCode: string;

  @Input() isMobile: boolean;

  constructor(injector: Injector,
    private mediaPictureService: MediaPictureService) {
    super(injector);
  }

  getModuleId(): string {
    return UserRecentActivityCardV2Component.MODULE_ID;
  }

  getPicture(picture: string): string | undefined {
    const urlWithoutHttp = picture.startsWith("https:") ? picture.split("https:")[1] : picture;
    return this.mediaPictureService.getMediaUrl(urlWithoutHttp, this.PICTURE_SIZE);
  }

  clickHandler(position: number, label: string, href: string) {
    this.upaService.trackClickTopic(this.getUpaData(position, label, href));
    window.open(href);
  }

  getUpaData(position: number, label?: string, href?: string) {
    return {...this.upaData,
      label: label ?? '',
      moduleId: this.getModuleId(),
      moduleIndex: this.upaData.row_number,
      uniqueId: this.uniqueId,
      positionIndex: position,
      href: href ?? this.searchLink,
      data: {city: this.destinationCode}
    };
  }
}
